
/* jshint ignore:start */
(function() {
  'use strict';

  // ── State ──────────────────────────────────
  var state = {
    currentStep: 1,
    hardware: [],
    addons: [],
    selectedTarif: { id: '', title: '', price: '' },
    portierung: false,
    kundentyp: '',
    uploadedFiles: {},
    ticketNr: 'PE-' + new Date().getFullYear() + '-' + Math.floor(Math.random()*90000+10000)
  };

  window.peState = state;
  window.peGoTo = peGoTo;
  window.peBuildSummary = peBuildSummary;

  // ── Tarif wählen ──────────────────────────────────
  window.peSelectTarif = function(card, id, title, price) {
    if (title.trim().charAt(0) === '+') {
      var selected = card.classList.contains('selected');
      state.addons = state.addons.filter(function(a) { return a.id !== id; });
      if (!selected && /flatrate/i.test(title)) {
        state.addons = state.addons.filter(function(a) { return !/flatrate/i.test(a.title); });
        document.querySelectorAll('.pe-tarif-card[data-pe-addon]').forEach(function(c) { if (/flatrate/i.test(c.dataset.variantTitle)) { c.classList.remove('selected'); c.querySelector('input').checked = false; } });
      }
      card.classList.toggle('selected', !selected);
      card.querySelector('input').checked = !selected;
      if (!selected) state.addons.push({id:id,title:title,price:price});
      return;
    }
    document.querySelectorAll('.pe-tarif-card:not([data-pe-addon])').forEach(function(c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    card.querySelector('input').checked = true;
    state.selectedTarif = { id: id, title: title, price: price };
    document.getElementById('pe-tarif-error').style.display = 'none';
  };

  // ── Portierung toggle ──────────────────────────────────
  window.peTogglePort = function(on) {
    state.portierung = on;
    document.getElementById('pe-port-fields').classList.toggle('show', on);
    document.getElementById('pe-docs-portierung').style.display = on ? 'block' : 'none';
  };

  // ── Kundentyp → Dokumenten-Sektionen ──────────────────────────────────
  window.peToggleDocs = function() {
    var kt = document.getElementById('pe-kundentyp').value;
    state.kundentyp = kt;
    // Firma required
    var firmaRequired = kt !== '' && kt !== 'privat';
    document.getElementById('firma-required').style.display = firmaRequired ? 'inline' : 'none';
    // Dokumenten-Bereiche
    document.getElementById('pe-docs-privat').style.display  = (kt === 'privat') ? 'block' : 'none';
    document.getElementById('pe-docs-firma').style.display   = (kt !== '' && kt !== 'privat') ? 'block' : 'none';
  };

  // ── File Upload ──────────────────────────────────
  window.peAddFile = function(input, type) {
    if (!input.files || !input.files[0]) return;
    var file = input.files[0];
    if (file.size > 10 * 1024 * 1024) { alert('Datei zu groß (max. 10 MB): ' + file.name); return; }
    state.uploadedFiles[type] = file;
    peRenderFileList();
    document.getElementById('pe-docs-error').style.display = 'none';
  };

  function peRenderFileList() {
    var list = document.getElementById('pe-file-list');
    list.innerHTML = '';
    Object.keys(state.uploadedFiles).forEach(function(type) {
      var file = state.uploadedFiles[type];
      var item = document.createElement('div');
      item.className = 'pe-file-item';
      item.innerHTML = '📎 ' + peDocLabel(type) + ': <strong>' + file.name + '</strong> (' + (file.size/1024/1024).toFixed(2) + ' MB)' +
        '<button class="pe-file-item-remove" onclick="peRemoveFile(\'' + type + '\')" title="Entfernen">✕</button>';
      list.appendChild(item);
    });
  }

  function peDocLabel(type) {
    var labels = { 'ausweis': 'Personalausweis', 'ausweis-gf': 'Ausweis GF', 'gewerbeschein': 'Gewerbeschein/HR-Auszug', 'portierung': 'Portierungsformular', 'vollmacht': 'Vollmacht' };
    return labels[type] || type;
  }

  window.peRemoveFile = function(type) { delete state.uploadedFiles[type]; peRenderFileList(); };

  // ── Validation ──────────────────────────────────
  function peValidateStep(step) {
    var ok = true;

    function check(id, condition) {
      var el = document.getElementById(id);
      var row = document.getElementById('fg-' + id.replace('pe-',''));
      if (!condition) {
        if (row) row.classList.add('pe-field-error');
        ok = false;
      } else {
        if (row) row.classList.remove('pe-field-error');
      }
    }

    if (step === 1) {
      check('pe-kundentyp', document.getElementById('pe-kundentyp').value !== '');
      check('pe-vorname', document.getElementById('pe-vorname').value.trim().length > 1);
      check('pe-nachname', document.getElementById('pe-nachname').value.trim().length > 1);
      check('pe-strasse', document.getElementById('pe-strasse').value.trim().length > 3);
      check('pe-plz', /^\d{4,5}$/.test(document.getElementById('pe-plz').value.trim()));
      check('pe-ort', document.getElementById('pe-ort').value.trim().length > 1);
      check('pe-email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(document.getElementById('pe-email').value.trim()));
      check('pe-telefon', document.getElementById('pe-telefon').value.trim().length > 5);
      check('pe-login-vorname', document.getElementById('pe-login-vorname').value.trim().length > 1);
      check('pe-login-nachname', document.getElementById('pe-login-nachname').value.trim().length > 1);
      check('pe-login-email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(document.getElementById('pe-login-email').value));
      var kt = document.getElementById('pe-kundentyp').value;
      if (kt !== 'privat' && kt !== '') {
        check('pe-firma', document.getElementById('pe-firma').value.trim().length > 1);
      }
    }

    if (step === 2) {
      if (!state.selectedTarif.id) {
        document.getElementById('pe-tarif-error').style.display = 'block';
        ok = false;
      }
      if (!document.getElementById('pe-nutzer').value || parseInt(document.getElementById('pe-nutzer').value) < 1) ok = false;
    }

    if (step === 4) {
      var kt = state.kundentyp;
      var needsDocs = false;
      if (kt === 'privat' && !state.uploadedFiles['ausweis']) needsDocs = true;
      if (kt !== 'privat' && kt !== '' && !state.uploadedFiles['gewerbeschein']) needsDocs = true;
      if (state.portierung && !state.uploadedFiles['portierung']) needsDocs = true;
      if (needsDocs) {
        document.getElementById('pe-docs-error').style.display = 'block';
        ok = false;
      }
    }

    return ok;
  }

  // ── Navigation ──────────────────────────────────
  window.peNext = function(from) {
    if (!peValidateStep(from)) { window.scrollTo({ top: document.getElementById('pe-placetel-form-wrap').offsetTop - 80, behavior: 'smooth' }); return; }
    peGoTo(from + 1);
  };

  window.pePrev = function(from) { peGoTo(from - 1); };

  function peGoTo(step) {
    document.querySelectorAll('.pe-phase').forEach(function(p) { p.classList.remove('active'); });
    document.getElementById('pe-phase-' + step).classList.add('active');

    document.querySelectorAll('.pe-step').forEach(function(s, i) {
      s.classList.remove('active', 'done');
      if (i + 1 === step) s.classList.add('active');
      else if (i + 1 < step) s.classList.add('done');
    });

    state.currentStep = step;
    if (step === 6) { peBuildSummary(); if (window.peBuildKosten) window.peBuildKosten(); }
    window.scrollTo({ top: document.getElementById('pe-placetel-form-wrap').offsetTop - 80, behavior: 'smooth' });
  }

  // ── Zusammenfassung ──────────────────────────────────
function peSummaryEscape(value) { return String(value).replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function peBuildSummary() {
    // Hardware in Summary einbauen
    var hwHtml = '';
    if (state.hardware && state.hardware.length > 0) {
      hwHtml = '<tr><td colspan="2" style="padding:8px 0 4px;font-weight:700;color:#0f172a;font-size:12px;border-top:1px solid #e2e8f0;">🖥️ Hardware</td></tr>';
      state.hardware.forEach(function(h) {
        hwHtml += '<tr><td style="color:#64748b;padding:3px 0;font-size:12px;">' + peSummaryEscape(h.name) + ' × ' + peSummaryEscape(h.qty) + '</td><td style="text-align:right;font-size:12px;">' + peSummaryEscape(h.price) + '</td></tr>';
      });
    } else {
      hwHtml = '<tr><td colspan="2" style="padding:8px 0 4px;font-weight:700;color:#0f172a;font-size:12px;border-top:1px solid #e2e8f0;">🖥️ Hardware</td></tr><tr><td colspan="2" style="color:#64748b;font-size:12px;">Keine Hardware gewünscht</td></tr>';
    }
    var portLabel = state.portierung ? 'Ja — ' + (peSummaryEscape(document.getElementById('pe-alt-anbieter').value) || 'Anbieter nicht angegeben') : 'Nein';
    var html = [
      '<b>Kundentyp:</b> ' + document.getElementById('pe-kundentyp').options[document.getElementById('pe-kundentyp').selectedIndex].text,
      peSummaryEscape(document.getElementById('pe-firma').value) ? '<b>Firma:</b> ' + peSummaryEscape(document.getElementById('pe-firma').value) : '',
      '<b>Name:</b> ' + peSummaryEscape(document.getElementById('pe-vorname').value) + ' ' + peSummaryEscape(document.getElementById('pe-nachname').value),
      '<b>Adresse:</b> ' + peSummaryEscape(document.getElementById('pe-strasse').value) + ', ' + peSummaryEscape(document.getElementById('pe-plz').value) + ' ' + peSummaryEscape(document.getElementById('pe-ort').value),
      '<b>E-Mail:</b> ' + peSummaryEscape(document.getElementById('pe-email').value),
      '<b>Telefon:</b> ' + peSummaryEscape(document.getElementById('pe-telefon').value),
      '─',
      '<b>Produkt:</b> ' + document.getElementById('pe-placetel-form-wrap').dataset.productTitle,
      '<b>Tarif:</b> ' + peSummaryEscape(state.selectedTarif.title) + ' (' + peSummaryEscape(state.selectedTarif.price) + ')',
      '<b>Zusatzoptionen:</b> ' + (state.addons || []).map(function(a) { return peSummaryEscape(a.title) + ' (' + peSummaryEscape(a.price) + ')'; }).join(', '),
      '<b>Nutzer:</b> ' + peSummaryEscape(document.getElementById('pe-nutzer').value),
      peSummaryEscape(document.getElementById('pe-startdatum').value) ? '<b>Starttermin:</b> ' + peSummaryEscape(document.getElementById('pe-startdatum').value) : '',
      '<b>Portierung:</b> ' + portLabel,
      '─',
      '<b>Hochgeladene Dokumente:</b> ' + Object.keys(state.uploadedFiles).map(peDocLabel).join(', ') || 'keine',
    ].filter(function(l) { return l; }).join('<br>');
    document.getElementById('pe-summary').innerHTML = html + '<table style="width:100%">' + hwHtml + '</table>';
  }

  // ── Submit Check ──────────────────────────────────
  window.peCheckSubmit = function() {};

  // ── Absenden ──────────────────────────────────
  window.peSubmit = function() {
    if (!document.getElementById('pe-check-agb').checked || !document.getElementById('pe-check-dsgvo').checked || !document.getElementById('pe-check-richtigkeit').checked) {
      document.getElementById('pe-agb-error').style.display = 'block';
      return;
    }
    document.getElementById('pe-agb-error').style.display = 'none';

    var btn = document.getElementById('pe-submit-btn');
    var previousError = document.getElementById('pe-order-submit-error');
    if (previousError) previousError.remove();
    btn.disabled = true;
    btn.textContent = btn.dataset.waitLabel || '⏳ Wird an PE übermittelt…';

    // FormData für Datei-Upload
    var fd = new FormData();
    fd.append('ticket', state.ticketNr);
    fd.append('produkt', document.getElementById('pe-placetel-form-wrap').dataset.productTitle);
    fd.append('produktHandle', document.getElementById('pe-placetel-form-wrap').dataset.productHandle);
    fd.append('tarifId', state.selectedTarif.id);
    fd.append('tarifTitle', state.selectedTarif.title);
    fd.append('tarifPreis', state.selectedTarif.price);
    fd.append('kundentyp', document.getElementById('pe-kundentyp').options[document.getElementById('pe-kundentyp').selectedIndex].text);
    fd.append('firma', document.getElementById('pe-firma').value);
    fd.append('vorname', document.getElementById('pe-vorname').value);
    fd.append('nachname', document.getElementById('pe-nachname').value);
    fd.append('strasse', document.getElementById('pe-strasse').value);
    fd.append('plz', document.getElementById('pe-plz').value);
    fd.append('ort', document.getElementById('pe-ort').value);
    fd.append('land', document.getElementById('pe-land').value);
    fd.append('email', document.getElementById('pe-email').value);
    fd.append('telefon', document.getElementById('pe-telefon').value);
    fd.append('ustid', document.getElementById('pe-ustid').value);
    fd.append('kundennr', document.getElementById('pe-kundennr').value);
    fd.append('loginVorname', document.getElementById('pe-login-vorname').value);
    fd.append('loginNachname', document.getElementById('pe-login-nachname').value);
    fd.append('loginEmail', document.getElementById('pe-login-email').value);
    fd.append('nutzer', document.getElementById('pe-nutzer').value);
    fd.append('startdatum', document.getElementById('pe-startdatum').value);
    fd.append('portierung', state.portierung ? 'ja' : 'nein');
    fd.append('altAnbieter', document.getElementById('pe-alt-anbieter').value);
    fd.append('portDatum', document.getElementById('pe-port-datum').value);
    fd.append('rufnummern', document.getElementById('pe-rufnummern').value);
    fd.append('anmerkungen', document.getElementById('pe-anmerkungen').value);
    fd.append('timestamp', new Date().toISOString());
    fd.append('source', 'placetel-bestellung');
    fd.append('hardware', JSON.stringify(state.hardware || []));
    fd.append('zusatzoptionen', JSON.stringify(state.addons || []));
    fd.append('kontoinhaber', document.getElementById('pe-kontoinhaber').value);
    fd.append('iban', document.getElementById('pe-iban').value.replace(/\s/g, ''));
    fd.append('bic', document.getElementById('pe-bic').value);
    fd.append('bank', document.getElementById('pe-bank').value);
    fd.append('sepaZustimmung', document.getElementById('pe-check-sepa').checked ? 'ja' : 'nein');
    fd.append('agbZustimmung', 'ja');
    fd.append('datenschutzZustimmung', 'ja');
    fd.append('richtigkeitBestaetigt', 'ja');

    // Dokumente anhängen
    Object.keys(state.uploadedFiles).forEach(function(type) {
      fd.append('doc_' + type, state.uploadedFiles[type], peDocLabel(type) + '_' + state.ticketNr + '.' + state.uploadedFiles[type].name.split('.').pop());
    });

    // Bestellunterlagen ausschließlich an den PE-eigenen Intake-Endpunkt senden
    fetch('https://n8n.premium-electronics.eu/webhook/placetel-bestellung', {
      method: 'POST',
      body: fd
    })
    .then(function(res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text().then(function(text) { if (text.trim().charAt(0) === '{') { var result = JSON.parse(text); if (result.success === false || result.error) throw new Error('Übermittlung nicht bestätigt'); } return text; }); })
    .then(function() { peShowSuccess(); })
    .catch(function(err) {
      console.error('Übermittlung an PE fehlgeschlagen:', err);
      btn.disabled = false;
      btn.textContent = btn.dataset.retryLabel || 'Bestellunterlagen erneut an PE übermitteln';
      var message = document.createElement('div');
      message.id = 'pe-order-submit-error';
      message.className = 'pe-tel-submit-error';
      message.setAttribute('role', 'alert');
      message.textContent = btn.dataset.errorMessage || 'Die Übermittlung an PE konnte nicht bestätigt werden.';
      btn.parentNode.before(message);
    });
  };

  // ── Erfolg anzeigen ──────────────────────────────────
  function peShowSuccess() {
    document.querySelectorAll('.pe-phase').forEach(function(p) { p.style.display = 'none'; });
    document.querySelectorAll('.pe-steps').forEach(function(s) { s.style.display = 'none'; });
    document.getElementById('pe-success').style.display = 'block';
    document.getElementById('pe-ticket-nr').textContent = 'Ticket-Nr.: ' + state.ticketNr;
    window.scrollTo({ top: document.getElementById('pe-placetel-form-wrap').offsetTop - 80, behavior: 'smooth' });
  }

  // ── Startdatum default: 2 Wochen ab heute ──────────────────────────────────
  
  var datInput = document.getElementById('pe-startdatum');
  if (datInput) {
    var d = new Date();
    d.setDate(d.getDate() + 14);
    datInput.min = new Date().toISOString().split('T')[0];
    datInput.value = d.toISOString().split('T')[0];
  }

})();

  function peToggleHardware(card, title, price) {
    card.classList.toggle('selected');
    var mengeDiv = card.querySelector('.pe-hw-menge');
    if (card.classList.contains('selected')) {
      mengeDiv.style.display = 'block';
      document.getElementById('pe-no-hw-btn').style.opacity = '0.4';
    } else {
      mengeDiv.style.display = 'none';
    }
    peUpdateHardwareSummary();
  }
  function peNoHardware() {
    document.querySelectorAll('.pe-hw-card.selected').forEach(function(c) {
      c.classList.remove('selected');
      c.querySelector('.pe-hw-menge').style.display = 'none';
    });
    document.getElementById('pe-no-hw-btn').style.opacity = '1';
    document.getElementById('pe-hw-summary').style.display = 'none';
    window.peState.hardware = [];
    peNext(3);
  }
  function peUpdateHardwareSummary() {
    var selected = [];
    document.querySelectorAll('.pe-hw-card.selected').forEach(function(c) {
      var name = c.querySelector('.pe-hw-name').textContent;
      var price = c.querySelector('.pe-hw-price').textContent;
      var qty = c.querySelector('.pe-hw-qty').value || 1;
      selected.push({ name: name, price: price, qty: qty });
    });
    window.peState.hardware = selected;
    var summaryDiv = document.getElementById('pe-hw-summary');
    var listDiv = document.getElementById('pe-hw-summary-list');
    if (selected.length > 0) {
      summaryDiv.style.display = 'block';
      listDiv.innerHTML = selected.map(function(i) {
        return '<div style="margin-bottom:3px;">• ' + i.name + ' × ' + i.qty + ' — ' + i.price + '</div>';
      }).join('');
    } else {
      summaryDiv.style.display = 'none';
    }
  }


document.querySelectorAll('.pe-tarif-card').forEach(function(card) { card.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); } }); });
